import React from 'react';

interface IProps {
  children: React.ReactNode;
  onClick?: () => void;
  extraClasses?: string;
  variant?: 'default' | 'success' | 'error' | 'gray';
  type?: 'default' | 'icon' | 'border';
}

const Button: React.FC<IProps> = ({
  children,
  onClick,
  extraClasses = '',
  variant = 'default',
  type = 'default',
}) => {
  const getColorClasses = () => {
    switch (variant) {
      case 'success':
        return 'bg-green-500 hover:bg-green-600 active:bg-green-700 dark:bg-green-400 dark:hover:bg-green-300 dark:active:opacity-90';
      case 'error':
        return 'bg-red-500 hover:bg-red-600 active:bg-red-700 dark:bg-red-400 dark:hover:bg-red-300 dark:active:opacity-90';
      case 'gray':
        return 'bg-gray-700 hover:bg-gray-600 active:bg-gray-700 dark:bg-gray-400 dark:hover:bg-gray-300 dark:active:opacity-90';
      default:
        return 'bg-brand-600 hover:bg-brand-700 active:bg-brand-800 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90';
    }
  };

  return (
    <button
      onClick={onClick}
      className={`linear ${
        type !== 'icon' ? 'min-w-[100px]' : ''
      } rounded-lg px-4 py-2 text-base font-medium uppercase tracking-wide text-white transition duration-200 ${getColorClasses()}  ${extraClasses}`}
    >
      {children}
    </button>
  );
};

export default Button;
